<template>
  <div>
    <v-img
      style="max-height: 300px"
      contain
      class="mx-auto"
      src="@/assets/amalay-print.png"
    ></v-img>
    <v-container class="d-flex flex-column justify-content center mt-10">
      <v-btn
        :to="{ name: 'menu', params: { id: item.slug } }"
        outlined
        color="white"
        v-for="item in menus"
        :key="item.key"
        class="mx-auto my-3 overline pa-6"
        style="max-width: 280px; min-width: 280px"
      >
        {{ item.name }}
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "HomeView",
  data() {
    return {};
  },
  computed: {
    ...mapState("menu",["menus"])
  }
};
</script>
